document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.reviews-container');
  const prevButton = document.querySelector('.nav-button.prev');
  const nextButton = document.querySelector('.nav-button.next');

  function updateReviewAlignment() {
    if (!container) return;

    const reviewCards = container.querySelectorAll('.review-card');
    if (reviewCards.length === 0) {
      container.style.justifyContent = 'center'; // Center if no cards
      return;
    }

    // Calculate total width of cards + gaps
    let totalWidth = 0;
    const gapStyle = window.getComputedStyle(container).getPropertyValue('gap');
    const gap = parseFloat(gapStyle) || 20; // Use computed gap or fallback

    reviewCards.forEach((card, index) => {
      totalWidth += card.offsetWidth;
      if (index < reviewCards.length - 1) {
        totalWidth += gap;
      }
    });

    // Use clientWidth which excludes padding/border/scrollbar width
    const containerWidth = container.clientWidth; 

    // Add a small tolerance to prevent slight overflows causing left alignment
    if (totalWidth < containerWidth - 1) { 
      container.style.justifyContent = 'center';
    } else {
      // Default or explicit flex-start for overflow/scrolling
      container.style.justifyContent = 'flex-start'; 
    }
  }

  // Calculate proper scroll amount based on viewport and card positioning
  function getScrollAmount() {
    if (!container) return 360; // fallback
    
    const reviewCards = container.querySelectorAll('.review-card');
    if (reviewCards.length === 0) return 360; // fallback
    
    // Get the actual width of the first card (they should all be the same)
    const firstCard = reviewCards[0];
    const cardWidth = firstCard.offsetWidth;
    
    // Get the gap between cards
    const gapStyle = window.getComputedStyle(container).getPropertyValue('gap');
    const gap = parseFloat(gapStyle) || 20;
    
    // On mobile, calculate scroll amount to center the next card
    const containerWidth = container.clientWidth;
    const isMobile = window.innerWidth <= 480;
    
    if (isMobile) {
      // For mobile, scroll exactly one card width + gap to center the next card
      return cardWidth + gap;
    }
    
    // Return card width + gap for smooth single-card scrolling on desktop
    return cardWidth + gap;
  }

  // Get the index of the currently visible/centered card
  function getCurrentCardIndex() {
    if (!container) return 0;
    
    const scrollLeft = container.scrollLeft;
    const cardWidth = container.querySelector('.review-card')?.offsetWidth || 360;
    const gap = parseFloat(window.getComputedStyle(container).getPropertyValue('gap')) || 20;
    
    return Math.round(scrollLeft / (cardWidth + gap));
  }

  // Scroll to a specific card index, centering it
  function scrollToCard(index) {
    if (!container) return;
    
    const reviewCards = container.querySelectorAll('.review-card');
    if (index < 0 || index >= reviewCards.length) return;
    
    const cardWidth = reviewCards[0]?.offsetWidth || 360;
    const gap = parseFloat(window.getComputedStyle(container).getPropertyValue('gap')) || 20;
    
    const scrollPosition = index * (cardWidth + gap);
    container.scrollTo({ left: scrollPosition, behavior: 'smooth' });
  }

  // Navigation functionality
  function setupNavigation() {
    if (!container || !prevButton || !nextButton) return;
    
    prevButton.addEventListener('click', function() {
      const currentIndex = getCurrentCardIndex();
      const reviewCards = container.querySelectorAll('.review-card');
      
      if (currentIndex > 0) {
        scrollToCard(currentIndex - 1);
      } else {
        // If at the beginning, go to the last card
        scrollToCard(reviewCards.length - 1);
      }
    });

    nextButton.addEventListener('click', function() {
      const currentIndex = getCurrentCardIndex();
      const reviewCards = container.querySelectorAll('.review-card');

      if (currentIndex < reviewCards.length - 1) {
        scrollToCard(currentIndex + 1);
      } else {
        // If at the end, go back to the first card
        scrollToCard(0);
      }
    });
  }
  
  // Initial alignment check and setup resize listener
  updateReviewAlignment();
  window.addEventListener('resize', updateReviewAlignment);

  // Ensure images are loaded before calculating width for accuracy
  // Using Promise.all to wait for all images inside cards to load
  const images = container ? container.querySelectorAll('.review-card img') : [];
  const imageLoadPromises = [];
  images.forEach(img => {
    if (!img.complete) {
      imageLoadPromises.push(new Promise(resolve => {
        img.onload = resolve;
        img.onerror = resolve; // Resolve even if image fails to load
      }));
    }
  });

  if (imageLoadPromises.length > 0) {
    Promise.all(imageLoadPromises).then(() => {
      updateReviewAlignment(); // Recalculate after images load
      setupNavigation(); // Setup navigation after images are loaded
    });
  } else {
    // If no images or all are complete, run alignment check once more just in case
    updateReviewAlignment();
    setupNavigation(); // Setup navigation immediately
  }
}); 